/**
 * @desc 获取当前时间
 * @returns {string}
 */
export const presentTime = () => {
  const date = new Date();
  const symbolic = "-";
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  return year + symbolic + month + symbolic + strDate;
};

// 获取最近六个月
export const getLastSixMon = () => {
  var data = new Date();
  //获取年
  var year = data.getFullYear();
  //获取月
  var mon = data.getMonth() + 1;
  var arry = new Array();
  for (var i = 0; i < 6; i++) {
    if (mon <= 0) {
      year = year - 1;
      mon = mon + 12;
    }
    if (mon < 10) {
      mon = "0" + mon;
    }
    arry[i] = year + "-" + mon;
    mon = mon - 1;
  }
  return {
    yearMonthStart: arry[5],
    yearMonthEnd: arry[0],
  };
};
